import { PopupAnnouncementDefinitions } from "./PopupAnnouncementDefinitions";
import ComponentHeader from "components/cms/ComponentHeader";
import PopupAnnouncementDesigner from "./PopupAnnouncementDesigner";

export class PopupAnnouncement extends PopupAnnouncementDefinitions {
    render() {
        const { className, designing } = this.props;
        return (
            <div
                data-schema-id={this.props.id}
                className={[
                    "fa-draggable fa-CardList",
                    designing && "designing",
                    className,
                ]
                    .filter((e) => !!e)
                    .join(" ")}
            >
                {designing && (
                    <ComponentHeader
                        componentEntry={this.props.entry}
                        componentSchemaId={this.props.id as string}
                    />
                )}
                {this.props.designing ? (
                    <PopupAnnouncementDesigner {...this.props} />
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
